import packageJson from '../../package.json'

export const apiVersion = 'v1'
export const actualSchemaVersion = '2.1.0'
export const uiVersion = packageJson.version
